import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets


import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import 'vue-search-select/dist/VueSearchSelect.css'

import ElementUI, {Notification} from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import App from './App'
import store from './store'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import { DataTables } from 'vue-data-tables'

import VueQRCodeComponent from 'vue-qrcode-component'

Vue.use(ElementUI, { locale })

Vue.use(DataTables)

const MyPlugin = {
  install(Vue, options) {
    Vue.component('qr-code', VueQRCodeComponent)
    Vue.prototype.$notifyloading = (message)=>{
      return Notification({
        iconClass: "el-icon-loading",
        title: 'Loading',
        message: message,
        duration: 0
      });
    }

    Vue.prototype.roleAuth = (roles)=>{
      const role = store.state.user.role
      return roles.includes(role)
    }
    
    Vue.prototype.role = {
      spadmin: 'superadmin',
      admin: 'admin',
      user: 'user',
    }
  },
}

Vue.use(MyPlugin)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

window.addEventListener('click', (e) => {
  // เช็คว่าสิ่งที่คลิกคือ ปุ่ม (button), ลิงก์ (a), หรือ class ของ Element UI (.el-button)
  const target = e.target.closest('button, a, .el-button');
  
  if (target && e.detail > 1) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}, true);
